import React, { useState } from "react";
import './Cile-Kits.scss';

const KitItemCard = ({ item, skuKit, editaPrecoItem, toggleModalExcluir, setItemExcluir }) => {

    const [editar, setEditar] = useState(false);
    const [preco, setPreco] = useState(item.preco.toFixed(2).toString().replace(".", ","));

    const handleInputChange = (e) => {
        const { value } = e.target;
        setPreco(value);
    };

    const editaItem = () => {
        editaPrecoItem(skuKit, item.idItem, item.skuItem, preco.replace(",", "."));
    }

    return (
        <>
            <div className="col-12">
                <div className="card-item border-bottom">
                    <div className="row no-gutters align-items-center">
                        <div className="col-1">
                            <p>SKU: {item.skuItem}</p>
                        </div>
                        <div className="col-6">
                            <p>{item.nome} </p>
                        </div>
                        <div className="col-1">
                            {editar ?
                                <>
                                    <input name="preco" type="text" className="form-control" autoComplete="off" value={preco} onChange={handleInputChange} />
                                    <button className='button-input' onClick={() => setEditar(false)}>
                                        x
                                    </button>
                                </>
                                :
                                <p>
                                    R$ {item.preco.toFixed(2).toString().replace(".", ",")}
                                </p>}
                        </div>
                        <div className="col-2 text-center">
                            {editar ?
                                <button className='btn btn-sm btn-outline-success' onClick={() => editaItem()}>
                                    Salvar
                                </button>
                                :
                                <button className='btn btn-sm btn-outline-info' onClick={() => setEditar(true)}>
                                    Editar Preço
                                </button>}
                        </div>
                        <div className="col-2 text-center">
                            <button className='btn btn-sm btn-outline-danger' onClick={() => setItemExcluir({ skuKit: skuKit, idItem: item.idItem, nome: item.nome }) + toggleModalExcluir()}>
                                Remover Item
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}


export default KitItemCard;